import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { AuthorisationService } from '../../../services/authorisation-service/authorisation-service.service';
import { LoggingService } from '../../../services/logging-service/logging.service';
import { MatSnackBar } from '@angular/material';
import { ChangePasswordModel } from '../../../models/change-password-model';
import { HttpErrorResponse } from '@angular/common/http';
import { UserSessionService } from '../../../services/user-session-service/user-session.service';
import { FieldMatchErrorMatcher } from '../../../shared/field-match.directive';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  // Model for storing the new password
  changePasswordModel: ChangePasswordModel = new ChangePasswordModel();
  attemptingChangePassword: boolean;
  invalidPassword: boolean;
  fieldMatchErrorMatcher = new FieldMatchErrorMatcher();

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private authorisationService: AuthorisationService,
    private loggingService: LoggingService, private snackBar: MatSnackBar, private userSession: UserSessionService) { }

  ngOnInit() {
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(this.appConfigService.ApplicationName, null, null, null));
    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));
  }

  changePassword() {
    this.attemptingChangePassword = true;
    this.authorisationService.changePassword(this.changePasswordModel).subscribe(response => {
      const snackbarRef = this.snackBar.open('Your password has been changed. You will now be logged out.', null, { duration: 3000 });
      snackbarRef.afterDismissed().subscribe(x => {
        this.userSession.logout();
      });

    }, (error => {
      const errorResponse = error as HttpErrorResponse;
      if (errorResponse.status === 401) {
        this.snackBar.open('Your details could not be verified. Please try again.', null, { duration: 3000 });
        this.attemptingChangePassword = false;
        return;
      }

      if (errorResponse.status === 500) {
        this.snackBar.open('Sorry, we can\'t do that. There appears to be a problem. Please try again.', null, { duration: 3000 });
        this.attemptingChangePassword = false;
        return;
      }
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-change-password/change-password/change-password.component.ts